import LandingHeader from '../components/landing/LandingHeader';
import HeroSection from '../components/landing/HeroSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import MarketplaceSection from '../components/landing/MarketplaceSection';
import NeverPaySection from '../components/landing/NeverPaySection';
import LedgerSection from '../components/landing/LedgerSection';
import HomeFaqSection from '../components/landing/HomeFaqSection';
import PartnerDoorsSection from '../components/landing/PartnerDoorsSection';
import FinalCTASection from '../components/landing/FinalCTASection';
import LandingFooter from '../components/landing/LandingFooter';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PAGE_META } from '@/data/pageMeta';
import usePageMeta from '@/hooks/usePageMeta';
import useStructuredData from '@/hooks/useStructuredData';
import { organizationLd } from '@/data/structuredData';

/**
 * The homepage belongs to one audience: the plaintiff.
 *
 * Sections follow REDESIGN.md §4. Attorneys and funders keep their own pages,
 * reached from the partner doors near the bottom and from the footer, rather
 * than splitting the fold three ways.
 *
 * No `landing.css` import and no `.mcl-landing` wrapper: every style here comes
 * from tokens plus co-located CSS Modules. This is the first page off the old
 * stylesheet.
 */
const Landing = () => {
  usePageMeta(PAGE_META.home);
  useStructuredData(organizationLd());

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [location.hash]);

  return (
    <div data-testid="landing-page">
      <LandingHeader />

      <main>
      <HeroSection />
      <HowItWorksSection />
      <MarketplaceSection />
      <NeverPaySection />
      <LedgerSection />
      <HomeFaqSection />
      <PartnerDoorsSection />
      <FinalCTASection />
      </main>

      <LandingFooter />
    </div>
  );
};

export default Landing;
